module.exports = __webpack_public_path__ + "static/2-cfd1924be992799505028af600a004e5.jpg";